/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPProcountorIntegrationSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPProcountorIntegrationSettings model module.
   * @module model/ERPProcountorIntegrationSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPProcountorIntegrationSettings</code>.
   * @alias module:model/ERPProcountorIntegrationSettings
   * @class
   */
  var exports = function() {
    var _this = this;






















  };

  /**
   * Constructs a <code>ERPProcountorIntegrationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPProcountorIntegrationSettings} obj Optional instance to populate.
   * @return {module:model/ERPProcountorIntegrationSettings} The populated <code>ERPProcountorIntegrationSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AuthorizedToUserID')) {
        obj['AuthorizedToUserID'] = ApiClient.convertToType(data['AuthorizedToUserID'], 'Integer');
      }
      if (data.hasOwnProperty('Crated')) {
        obj['Crated'] = ApiClient.convertToType(data['Crated'], 'Date');
      }
      if (data.hasOwnProperty('AccessToken')) {
        obj['AccessToken'] = ApiClient.convertToType(data['AccessToken'], 'String');
      }
      if (data.hasOwnProperty('AccessTokenExpirationDate')) {
        obj['AccessTokenExpirationDate'] = ApiClient.convertToType(data['AccessTokenExpirationDate'], 'Date');
      }
      if (data.hasOwnProperty('RefreshToken')) {
        obj['RefreshToken'] = ApiClient.convertToType(data['RefreshToken'], 'String');
      }
      if (data.hasOwnProperty('LastUpdated')) {
        obj['LastUpdated'] = ApiClient.convertToType(data['LastUpdated'], 'Date');
      }
      if (data.hasOwnProperty('SyncActive')) {
        obj['SyncActive'] = ApiClient.convertToType(data['SyncActive'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncProductsLastDate')) {
        obj['SyncProductsLastDate'] = ApiClient.convertToType(data['SyncProductsLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncCustomersLastDate')) {
        obj['SyncCustomersLastDate'] = ApiClient.convertToType(data['SyncCustomersLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncInvoicesLastDate')) {
        obj['SyncInvoicesLastDate'] = ApiClient.convertToType(data['SyncInvoicesLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncAccountingLastDate')) {
        obj['SyncAccountingLastDate'] = ApiClient.convertToType(data['SyncAccountingLastDate'], 'Date');
      }
      if (data.hasOwnProperty('SyncProducts')) {
        obj['SyncProducts'] = ApiClient.convertToType(data['SyncProducts'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncCustomers')) {
        obj['SyncCustomers'] = ApiClient.convertToType(data['SyncCustomers'], 'Boolean');
      }
      if (data.hasOwnProperty('IsInitialRunDone')) {
        obj['IsInitialRunDone'] = ApiClient.convertToType(data['IsInitialRunDone'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('LastReceiptIdAfterError')) {
        obj['LastReceiptIdAfterError'] = ApiClient.convertToType(data['LastReceiptIdAfterError'], 'Integer');
      }
      if (data.hasOwnProperty('LastInvoiceIdAfterError')) {
        obj['LastInvoiceIdAfterError'] = ApiClient.convertToType(data['LastInvoiceIdAfterError'], 'Integer');
      }
      if (data.hasOwnProperty('UseOpeningBalances')) {
        obj['UseOpeningBalances'] = ApiClient.convertToType(data['UseOpeningBalances'], 'Boolean');
      }
      if (data.hasOwnProperty('SyncPurchaseInvoicesLastDate')) {
        obj['SyncPurchaseInvoicesLastDate'] = ApiClient.convertToType(data['SyncPurchaseInvoicesLastDate'], 'Date');
      }
      if (data.hasOwnProperty('StartAccountingFromDate')) {
        obj['StartAccountingFromDate'] = ApiClient.convertToType(data['StartAccountingFromDate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} AuthorizedToUserID
   * @default 0
   */
  exports.prototype['AuthorizedToUserID'] = 0;
  /**
   * @member {Date} Crated
   */
  exports.prototype['Crated'] = undefined;
  /**
   * @member {String} AccessToken
   * @default ''
   */
  exports.prototype['AccessToken'] = '';
  /**
   * @member {Date} AccessTokenExpirationDate
   */
  exports.prototype['AccessTokenExpirationDate'] = undefined;
  /**
   * @member {String} RefreshToken
   * @default ''
   */
  exports.prototype['RefreshToken'] = '';
  /**
   * @member {Date} LastUpdated
   */
  exports.prototype['LastUpdated'] = undefined;
  /**
   * @member {Boolean} SyncActive
   * @default false
   */
  exports.prototype['SyncActive'] = false;
  /**
   * @member {Date} SyncProductsLastDate
   */
  exports.prototype['SyncProductsLastDate'] = undefined;
  /**
   * @member {Date} SyncCustomersLastDate
   */
  exports.prototype['SyncCustomersLastDate'] = undefined;
  /**
   * @member {Date} SyncInvoicesLastDate
   */
  exports.prototype['SyncInvoicesLastDate'] = undefined;
  /**
   * @member {Date} SyncAccountingLastDate
   */
  exports.prototype['SyncAccountingLastDate'] = undefined;
  /**
   * @member {Boolean} SyncProducts
   * @default false
   */
  exports.prototype['SyncProducts'] = false;
  /**
   * @member {Boolean} SyncCustomers
   * @default false
   */
  exports.prototype['SyncCustomers'] = false;
  /**
   * @member {Boolean} IsInitialRunDone
   * @default false
   */
  exports.prototype['IsInitialRunDone'] = false;
  /**
   * @member {Integer} CompanyLegalEntityID
   * @default 0
   */
  exports.prototype['CompanyLegalEntityID'] = 0;
  /**
   * @member {Integer} LastReceiptIdAfterError
   */
  exports.prototype['LastReceiptIdAfterError'] = undefined;
  /**
   * @member {Integer} LastInvoiceIdAfterError
   */
  exports.prototype['LastInvoiceIdAfterError'] = undefined;
  /**
   * @member {Boolean} UseOpeningBalances
   * @default false
   */
  exports.prototype['UseOpeningBalances'] = false;
  /**
   * @member {Date} SyncPurchaseInvoicesLastDate
   */
  exports.prototype['SyncPurchaseInvoicesLastDate'] = undefined;
  /**
   * @member {Date} StartAccountingFromDate
   */
  exports.prototype['StartAccountingFromDate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


